import React from 'react';
import { motion } from 'framer-motion';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  delay?: number;
}
export function GlassCard({
  children,
  className = '',
  hoverEffect = false,
  delay = 0
}: GlassCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={hoverEffect ? {
    y: -5,
    boxShadow: '0 10px 40px -10px rgba(0,217,255,0.15)'
  } : {}} className={`
        relative overflow-hidden
        backdrop-blur-xl bg-white/5 border border-white/10
        rounded-2xl p-6
        ${className}
      `} data-id="element-123">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-124" />

      {/* Content */}
      <div className="relative z-10" data-id="element-125">{children}</div>
    </motion.div>;
}